export const loadingStatusType = {
  Success: "success",
  Error: "error",
  Loading: "loading",
};
